/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
function singleClassComponent(displayName, cssClass, TagName) {
    if (TagName === void 0) { TagName = "div"; }
    var component = function (_a) {
        var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
        return (React.createElement(TagName, tslib_1.__assign({ className: classnames(cssClass, className) }, props), children));
    };
    component.displayName = displayName;
    component.propTypes = {
        className: PropTypes.string
    };
    return component;
}
exports.singleClassComponent = singleClassComponent;